import SEO from '../components/SEO/SEO'
import BookNow from '../components/BookNow/BookNow'

export default function BookNowPage() {
  return (
    <>
      <SEO
        title="Book a Tattoo Session | Jesse B Tattoos Adelaide"
        description="Book your tattoo session with Jesse B Tattoos in Adelaide. Custom tattoos, Tattoo Therapy, and touch-ups. Secure your slot online."
        canonical="https://jessebtattoos.com/book"
        keywords="tattoo booking Adelaide, Jesse B Tattoos, custom tattoos Adelaide, tattoo therapy Adelaide, book tattoo session"
        ogType="website"
      />
      <BookNow />
    </>
  )
}